import React, { useEffect, useRef } from "react";
import FeaturedVideos from "./FeaturedVideos";
import PopulatVideos from "./PopulatVideos";
import TopProfiles from "./TopProfiles";
import News from "./News";
import { eventTracking } from "../../../firebaseAnalytics";
import { events } from "../../../Utilities/appEvents";
import GoogleAds from "../../GoogleAds/GoogleAds";
const WorldOfEsports = ({ handleClickBlog }) => {
  useEffect(() => {
    EventTracking();
  }, []);
  const EventTracking = () => {
    eventTracking(events.MENU.WOE);
  }
  return (
    <div class="row gy-5">
      {/* 
      <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <div style={{ width: '100%', maxWidth: '728px' }}>
          <ins
            className="adsbygoogle"
            style={{ display: 'block', width: '100%' }}
            data-ad-client="ca-pub-6031956815009779"
            data-ad-slot="3230396396"
            data-ad-format="autorelaxed"
            ref={adRef}
          />
        </div>
      </div>
 <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <div style={{ width: '100%', maxWidth: '728px' }}>
          <ins
            className="adsbygoogle"
            style={{ display: 'block', width: '100%' }}
            data-ad-client="ca-pub-6031956815009779"
            data-ad-slot="3230396396"
            data-ad-format="autorelaxed"
            ref={adRef}
          />
        </div>
      </div>
     */}
      <FeaturedVideos />
      <PopulatVideos />
    
          <GoogleAds
            adUnitPath="/157165500,23206251223/MCM_Gj_Console/MCM_Gj_Console_banner_1"
            sizes={[[728, 90], [336, 280]]}
            divId={`gpt-banner-1`}
          />
       
      <TopProfiles />
      <News handleClickBlog={handleClickBlog} />
    </div>
  );
};

export default WorldOfEsports;
